export const GET_USER = "GET_USER";
export const GET_USER_FAILURE = "GET_USER_FAILURE";
export const GET_USER_SUCCESS = "GET_USER_SUCCESS";

export const UPDATE_USER = "UPDATE_USER";
export const UPDATE_USER_FAILURE = "UPDATE_USER_FAILURE";
export const UPDATE_USER_SUCCESS = "UPDATE_USER_SUCCESS";
